
{
  "title": "Photo",
  "labels": {
    "upload": "Drag & drop or choose a photo to upload",
    "select": "Select Photo"
  }
}
